// Copyright (C) 2021 Bystronic Laser AG

export function getProductivity(
  bendingTimeSeconds: number | null,
  actualTimeSeconds: number,
): number | null {
  if (bendingTimeSeconds === null) {
    return null;
  }
  return (bendingTimeSeconds / actualTimeSeconds) * 100;
}
